'use client';

import { useRef } from 'react';
import { Provider } from 'react-redux';
import { makeStore, type ReduxAppStore, type RootState } from './redux-store';

export default function ReduxStoreProvider({
  children,
  preloadedState,
}: {
  children: React.ReactNode;
  preloadedState?: Partial<RootState>;
}) {
  const storeRef = useRef<ReduxAppStore>(undefined);
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore(preloadedState);
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
